import { render, staticRenderFns } from "./GestionCurso.vue?vue&type=template&id=2473160a&scoped=true"
import script from "./GestionCurso.vue?vue&type=script&lang=js"
export * from "./GestionCurso.vue?vue&type=script&lang=js"
import style0 from "./GestionCurso.vue?vue&type=style&index=0&id=2473160a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2473160a",
  null
  
)

export default component.exports